module.exports = __webpack_public_path__ + "static/media/img4.f8d1c597.jpg";